"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const RoomCard_1 = require("@/common/components/RoomCard");
const functions_1 = require("@/common/functions");
const _1 = require(".");
exports.default = (0, react_1.memo)(function ({ data: mainGridData, isLoggedIn, maxWidth768, isPopMain, }) {
    const { id: roomId, category_id } = mainGridData;
    const [pending, setPending] = (0, react_1.useState)(false);
    const queryClient = (0, react_query_1.useQueryClient)();
    const onLikeChanged = (liked) => (0, _1.onMainRoomGridLikeChange)({ queryClient, roomId, liked });
    const changeLikeStateFn = () => {
        if (!pending) {
            (0, functions_1.changeLikeState)({
                isLoggedIn,
                setPending,
                roomId,
                onLikeChanged,
            });
        }
    };
    const isStoryData = Boolean(category_id);
    if (isStoryData) {
        return (0, jsx_runtime_1.jsx)(RoomCard_1.StoryCardA, { storyData: mainGridData, maxWidth768: maxWidth768, isMasonryMobile: true });
    }
    return ((0, jsx_runtime_1.jsx)(RoomCard_1.RoomCardA, { roomData: mainGridData, changeLikeStateFn: changeLikeStateFn, maxWidth768: maxWidth768, isMasonryMobile: true, isPopMain: isPopMain }));
});
